import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithCamelize } from "../apiTools";

export const rootApi = createApi({
  baseQuery: baseQueryWithCamelize,
  reducerPath: "rootApi",
  tagTypes: [
    "shareRangeAnalysisEvents",
    "locationAnalysisEvents",
    "proxyEventChangeRequests",
    "proxyEvents",
    "proxyEventMaterials",
    "proxyEventProposals",
    "proxyEventDateStats",
    "proxyEventAdditionalMailings",
    "proxyEventVoteSolicitations",
    "tabulationReports",
    "bankruptcyEvents",
    "bankruptcyEventDocuments",
    "classActionEvents",
    "classActionEventDocuments",
    "globalSearchCustomers",
    "globalSearchSecurities",
    "globalSearchJobNumbers",
    "noboEvents",
    "additionalMailings",
    "additionalMailingDocuments",
    "additionalMailingRequests",
    "issuer",
    "securities",
    "currentUser",
    "users",
    "institutionNotifications",
    "dashboard",
  ],
  endpoints: () => ({}),
});
